export default __webpack_public_path__ + "static/media/ai_send_icon.7422b182.svg";